export const SUPPORTED_IMAGE_FORMATS = ['jpg', 'png', 'jpeg', 'svg', 'gif', 'webp'];
export const SUPPORTED_VIDEO_FORMATS = ['avi', 'mp4', 'mov'];
export const SUPPORTED_AUDIO_FORMATS = ['mp3'];
